import { render, staticRenderFns } from "./ShopSendQueryModal.vue?vue&type=template&id=23336fd1&scoped=true&"
import script from "./ShopSendQueryModal.vue?vue&type=script&lang=js&"
export * from "./ShopSendQueryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23336fd1",
  null
  
)

export default component.exports